import { render, staticRenderFns } from "./PreviewWatermark.vue?vue&type=template&id=499f642c"
import script from "./PreviewWatermark.vue?vue&type=script&lang=js"
export * from "./PreviewWatermark.vue?vue&type=script&lang=js"
import style0 from "./PreviewWatermark.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports